//
// Copyright (C) 2018 jobsta
//
// This file is part of ReportBro, a library to generate PDF and Excel reports.
// Demos can be found at https://www.reportbro.com
//
// Dual licensed under AGPLv3 and ReportBro commercial license:
// https://www.reportbro.com/license
//
// You should have received a copy of the GNU Affero General Public License
// along with this program. If not, see https://www.gnu.org/licenses/
//
// Details for ReportBro commercial license can be found at
// https://www.reportbro.com/license/agreement
//

import React from 'react';
import ReactDOM from 'react-dom';
import ReportBro from './ReportBro';
import 'spectrum-colorpicker';

import './main.css';

export default class ReportBroMain extends React.Component {
    componentDidMount = () => {
        const element = $(ReactDOM.findDOMNode(this));
        const options = this.props.options || {};
        const rb = new ReportBro(element, options);
        element.data('reportBro', rb);
        rb.render();
        rb.setup();
        if (typeof this.props.getRef === 'function') this.props.getRef(rb);
    }
    render = () => <div className='react-reportbro-designer' />
}


// WEBPACK FOOTER //
// ./src/main.js